import { Line, LineProps } from 'recharts';

type LineWithDashedEndProps = Omit<LineProps, 'ref'> & {
  dashArrayIndex: number;
  stroke: string; // Required
};
// Why a function and not a component: https://github.com/recharts/recharts/issues/412#issuecomment-2260273464
export function lineWithDashedEnd({
  dashArrayIndex,
  data,
  animationDuration = 500,
  animationEasing = 'ease-out',
  ...props
}: LineWithDashedEndProps) {
  // Use modulo to allow negative index
  const pct = ((data.length + dashArrayIndex) % data.length) / data.length;

  return [
    <defs key="line-with-dashed-end-defs">
      <linearGradient id="lineUntilDash" x1="0%" y1="0" x2="100%" y2="0">
        <stop offset="0%" stopColor={props.stroke} />
        <stop offset={`${pct * 100}%`} stopColor={props.stroke} />
        <stop offset={`${pct * 100}%`} stopColor="transparent" />
        <stop offset="100%" stopColor="transparent" />
      </linearGradient>
    </defs>,

    <Line
      key="line1"
      {...props}
      stroke="url(#lineUntilDash)"
      animationDuration={animationDuration}
      animationEasing={animationEasing}
    />,
    <Line
      key="line2"
      {...props}
      strokeDasharray="2 2"
      dot={false}
      animationDuration={animationDuration}
      animationEasing={animationEasing}
    />,
  ];
}
